import en from './types/en';
import vn from './types/vn';
const languages = {
    en,
    vn,
};
export default languages;
